export default "__VITE_ASSET__DDwYglV9__"